/* Shared native scrolling for reviews and technologies (KB C-01). */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let sequence = 0;
  const manualSections = new Set();
  // Batch every carousel's geometry reads before any control/style updates.
  const measures = new Set();
  let measureFrame;
  function measureLater(measure) {
    measures.add(measure);
    if (measureFrame) return;
    measureFrame = requestAnimationFrame(() => {
      measureFrame = 0;
      const batch = [...measures]; measures.clear();
      const writes = batch.map(read => read()).filter(Boolean);
      writes.forEach(write => write());
    });
  }
  function mount(track) {
    if (track.dataset.carouselReady) return;
    track.dataset.carouselReady = 'true';
    const tech = track.classList.contains('tech-track');
    const section = track.closest('section');
    const key = section.closest('[id]')?.id || (tech ? 'technologies' : 'reviews');
    const frame = document.createElement('div');
    frame.className = 'bn-carousel';
    track.before(frame);frame.append(track);
    track.classList.add('bn-carousel-track');
    track.id ||= 'bn-carousel-' + (++sequence);
    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-roledescription', 'carusel');
    track.setAttribute('aria-label', tech ? 'Platforme și tehnologii' : 'Recenziile clienților');
    const dots = document.createElement('div');dots.className = 'bn-carousel-dots';dots.setAttribute('aria-label','Pozițiile caruselului');
    frame.after(dots);
    const arrow = (direction, label) => {
      const button = document.createElement('button');button.type = 'button';
      button.className = 'bn-carousel-arrow bn-carousel-' + (direction < 0 ? 'prev' : 'next');
      button.setAttribute('aria-label', label);button.setAttribute('aria-controls',track.id);
      button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="'+(direction < 0 ? 'm15 5-7 7 7 7' : 'm9 5 7 7-7 7')+'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.addEventListener('click', () => {stopAuto();go(active + direction);});frame.append(button);return button;
    };
    const prev = arrow(-1,'Poziția anterioară'), next = arrow(1,'Poziția următoare');
    let positions = [], active = 0, timer, pointer, suppressClick = false;
    let stopped = manualSections.has(key), disposed = false, inView = false;
    function stopAuto() {stopped = true;manualSections.add(key);clearTimeout(timer);}
    function scheduleAuto() {
      clearTimeout(timer);
      if (!tech || !inView || document.hidden || stopped || reduced.matches || disposed || positions.length < 2) return;
      timer = setTimeout(() => {
        if (inView && !document.hidden && !frame.matches(':hover,:focus-within')) go(active === positions.length - 1 ? 0 : active + 1);
        scheduleAuto();
      },3500);
    }
    function go(index, instant = false) {
      track.scrollTo({left:positions[Math.max(0,Math.min(positions.length - 1,index))] || 0,behavior:instant || reduced.matches ? 'instant' : 'smooth'});
    }
    function update(scrollLeft = track.scrollLeft) {
      active = positions.reduce((best,x,i) => Math.abs(x-scrollLeft) < Math.abs(positions[best]-scrollLeft) ? i : best,0);
      [...dots.children].forEach((button,i) => {button.setAttribute('aria-current',String(i === active));});
      prev.disabled = active === 0;next.disabled = active === positions.length - 1;
    }
    function resize() { measureLater(measure); }
    function measure() {
      if (disposed || !track.isConnected) return;
      const scrollLeft = track.scrollLeft;
      const max = Math.max(0,track.scrollWidth-track.clientWidth);
      const origin = track.getBoundingClientRect().left + track.clientLeft;
      const targets = [...track.children].map(item => Math.min(max,Math.max(0,item.getBoundingClientRect().left-origin+scrollLeft)));
      let nextPositions = targets.filter((x,i) => i === 0 || Math.abs(x-targets[i-1]) > 2);
      if (!nextPositions.length) nextPositions = [0];
      if (Math.abs(nextPositions.at(-1)-max) > 2) nextPositions.push(max);
      return () => {
      if (disposed) return;
      positions = nextPositions;
      if (dots.children.length !== positions.length) {
        const focus = dots.contains(document.activeElement);
        dots.replaceChildren(...positions.map((_,i) => {
          const button = document.createElement('button');button.type='button';button.className='bn-carousel-dot';
          button.setAttribute('aria-label','Mergi la poziția '+(i+1)+' din '+positions.length);button.setAttribute('aria-controls',track.id);
          button.addEventListener('click',() => {stopAuto();go(i);});return button;
        }));
        if (focus) dots.children[Math.min(active,positions.length-1)]?.focus({preventScroll:true});
      }
      const single = positions.length < 2;
      dots.hidden = prev.hidden = next.hidden = single;
      update(scrollLeft);scheduleAuto();
      };
    }
    frame.addEventListener('focusin',stopAuto);
    dots.addEventListener('focusin',stopAuto);
    let scrollFrame;
    track.addEventListener('scroll',() => { if (!scrollFrame) scrollFrame = requestAnimationFrame(() => {scrollFrame = 0;if (!disposed) update();}); },{passive:true});
    track.addEventListener('wheel',stopAuto,{passive:true});
    track.addEventListener('keydown',event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();stopAuto();go(event.key === 'Home' ? 0 : event.key === 'End' ? positions.length-1 : active+(event.key === 'ArrowLeft' ? -1 : 1));
    });
    track.addEventListener('dragstart',event => event.preventDefault());
    track.addEventListener('pointerdown',event => {
      stopAuto();suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,dragged:false};
    });
    track.addEventListener('pointermove',event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX-pointer.x;
      if (!pointer.dragged && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(event.clientY-pointer.y)) {
        pointer.dragged = true;track.setPointerCapture(event.pointerId);track.classList.add('is-dragging');
      }
      if (pointer.dragged) {event.preventDefault();track.scrollLeft=pointer.left-dx;}
    });
    function release(event) {
      if (!pointer || pointer.id !== event.pointerId) return;
      const dragged = pointer.dragged;pointer = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      if (dragged) {suppressClick=true;update();go(active);}
    }
    track.addEventListener('pointerup',release);track.addEventListener('pointercancel',release);
    track.addEventListener('lostpointercapture',release);
    track.addEventListener('pointerleave',event => {if(pointer && !pointer.dragged) release(event);});
    track.addEventListener('click',event => {if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;}},true);
    const observer = new ResizeObserver(resize);observer.observe(track);
    const visibility = new IntersectionObserver(entries => {inView = entries[0].isIntersecting;scheduleAuto();});
    visibility.observe(frame);
    document.addEventListener('visibilitychange', scheduleAuto);
    const motionChanged = () => {if(reduced.matches)clearTimeout(timer);else scheduleAuto();};
    reduced.addEventListener('change',motionChanged);
    track.bnCarouselDestroy = () => {disposed=true;clearTimeout(timer);cancelAnimationFrame(scrollFrame);measures.delete(measure);observer.disconnect();visibility.disconnect();document.removeEventListener('visibilitychange', scheduleAuto);reduced.removeEventListener('change',motionChanged);};
    resize();
  }
  const init = (root=document) => root.querySelectorAll('.svc-review-track,.tech-track').forEach(mount);
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-carousel-ready]').forEach(track=>track.bnCarouselDestroy?.()));
})();
